module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/layla-d5a91d27e1b6d87eeff61d588f4a4643.mp3";